import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Heading1: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 12h8' }],
    ['path', { d: 'M4 18V6' }],
    ['path', { d: 'M12 18V6' }],
    ['path', { d: 'm17 12 3-2v8' }],
  ],
];

export default Heading1;
